module.exports = __webpack_public_path__ + "img/progressBar-fulfill.902f394b.png";